import styled, { css } from 'styled-components';

const styles = css`
  .product-tile-container {
    width: 245px;
    height: 402px;
    background-color: #fff;
    border-radius: 10px;
    box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.12);
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      width: 144px;
      height: 249px;
    }
  }
  .product-tile {
    padding: 8px;
    @media ${(props) => props.theme.mediaQuery.medium} {
      padding: 14px;
    }
  }

  .price-atb-container {
    display: flex;
    justify-content: space-between;
    padding-bottom: 4px;
    position: relative;
  }
  .custom-ranking-container {
    position: relative;
  }
  .floating-atb-btn {
    position: absolute;
    top: 0;
    right: 0;
  }
  .fromStoreSpecialCaraosal {
    background: none;
    padding: 0;
    .promo_price {
      color: #c8102e;
      font-family: Nunito;
      font-size: 12px;
      font-style: normal;
      font-weight: 700;
      line-height: 150%; /* 18px */
    }
    .promo_message {
      color: #c8102e;
      font-family: Nunito;
      font-size: 12px;
      font-style: normal;
      font-weight: 400;
      line-height: 150%; /* 18px */
      letter-spacing: -0.024px;
    }
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      .promo_message,
      .promo_price {
        font-size: 9px;
      }

      .promo_message {
        letter-spacing: -0.018px;
      }
    }
  }
`;
export default styles;

export const StyledProduct = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  .moduleTabbed_carousel_img {
    display: flex;
    width: 217px;
    height: 270px;
    margin-bottom: 10px;
    @media ${(props) => props.theme.mediaQuery.medium} {
      margin-bottom: 24px;
    }
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      width: 128px;
      height: 158px;
    }
  }
`;
